import {
  ExtendedCriterion,
  Recruitment,
  useForm,
  useCriteriaCountByState,
  useParticipantFieldsByName,
  useQuotas,
} from '@app/api';
import { useMemo } from 'react';
import { useProcessedCriteria } from './useRecruitmentQuotas';

export const useRecruitmentExtendedCriterion = (
  recruitment: Recruitment | undefined,
): {
  audienceCriteria: ExtendedCriterion[];
  screeningCriteria: ExtendedCriterion[];
  isLoading: boolean;
} => {
  const { data: form, isLoading: formIsLoading } = useForm(
    recruitment?.screeningFormId,
  );
  const { data: criteriaCountByState } = useCriteriaCountByState(
    recruitment?.id,
  );
  const { data: quotas, isLoading: quotaAreLoading } = useQuotas(
    recruitment?.sessionId,
    null,
    true,
  );
  const participantFields = useParticipantFieldsByName();
  const criteriaWithQuota = useMemo(() => {
    return (
      recruitment?.criteria?.filter(
        (criterion) =>
          !!criterion.quotas ||
          quotas?.find((q) => q.ref === criterion.fieldRef),
      ) || []
    );
  }, [recruitment, quotas]);

  const audienceCriteriaWithQuotaLabel = useProcessedCriteria({
    criteria: criteriaWithQuota.filter((c) => !c.screenerCriterion),
    participantFields,
    criteriaCountByState,
  });

  const screeningCriteriaWithForm = useProcessedCriteria({
    criteria: criteriaWithQuota.filter((c) => c.screenerCriterion),
    participantFields,
    quotas,
    formFields: form?.fields,
    criteriaCountByState,
  });

  return {
    audienceCriteria: audienceCriteriaWithQuotaLabel,
    screeningCriteria: screeningCriteriaWithForm,
    isLoading: formIsLoading || quotaAreLoading,
  };
};
